<ion-grid style="border: 1px solid #bebebe;border-radius: 20px;padding: 10px;">
    <ion-row [ngClass]="isManagement ? 'management-heading' : 'heading'">
        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" size="3"></ion-col>
        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" size="9">
            <ion-grid>
                <ion-row>
                    <ng-container *ngIf="useTranslationOnOverallEvaluation; else usePossibleValues">
                        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" centered
                                 *ngFor="let rating of user?.ratings?.ratingsPossibleValuesGlobalized[selectedLanguage]; let ratingIndex = index">
                            {{ rating }}
                        </ion-col>
                    </ng-container>
                    <ng-template #usePossibleValues>
                        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" *ngFor="let rating of user?.ratings?.ratingsPossibleValues" centered>
                            {{ rating }}
                        </ion-col>
                    </ng-template>
                    <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'">
                        TOTAL
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
    <ion-row [ngClass]="isManagement ? 'management-body' : 'body'">
        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" size="3">
            <ion-grid>
                <ion-row>
                    <ion-col [ngClass]="isManagement ? 'management-col-style first-col' : 'col-style first-col'">
                        360º
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" size="9">
            <ion-grid>
                <ion-row>
                    <ng-container *ngIf="showTooltips; else threeSixtyWithTooltip">
                        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" centered *ngFor="let rating of user?.ratings?.ratingsPossibleValues"
                                 [matTooltip]="user?.evaluators?.threeSixtyEvaluators[rating]">
                            {{ user?.ratings?.threeSixtyRatings[rating] }}
                        </ion-col>
                        <ion-col [ngClass]="isManagement ? 'management-last-col-style' : 'col-style last-col'" centered [matTooltip]="getAllEvaluators(user?.evaluators?.threeSixtyEvaluators)">
                            {{ getTotalEvaluators(user?.ratings?.threeSixtyRatings) }}
                        </ion-col>
                    </ng-container>
                    <ng-template #threeSixtyWithTooltip>
                        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" centered *ngFor="let rating of user?.ratings?.ratingsPossibleValues">
                            {{ user?.ratings?.threeSixtyRatings[rating] }}
                        </ion-col>
                        <ion-col [ngClass]="isManagement ? 'management-last-col-style' : 'col-style last-col'" centered>
                            {{ getTotalEvaluators(user?.ratings?.threeSixtyRatings) }}
                        </ion-col>
                    </ng-template>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
    <ion-row [ngClass]="isManagement ? 'management-body' : 'body'" *ngIf="user?.user?.isManager">
        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" size="3">
            <ion-grid>
                <ion-row>
                    <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" class="first-col">
                        {{ 'generic.employees' | translate }}
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" size="9">
            <ion-grid>
                <ion-row>
                    <ng-container *ngIf="showTooltips; else withTooltipDR">
                        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" centered *ngFor="let rating of user?.ratings?.ratingsPossibleValues"
                                 [matTooltip]="user?.evaluators?.directReportEvaluators[rating]">
                            {{ user?.ratings?.directReportRatings[rating] }}
                        </ion-col>
                        <ion-col [ngClass]="isManagement ? 'management-last-col-style' : 'col-style last-col'" centered [matTooltip]="getAllEvaluators(user?.evaluators?.directReportEvaluators)">
                            {{ getTotalEvaluators(user?.ratings?.directReportRatings) }}
                        </ion-col>
                    </ng-container>
                    <ng-template #withTooltipDR>
                        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" centered *ngFor="let rating of user?.ratings?.ratingsPossibleValues">
                            {{ user?.ratings?.directReportRatings[rating] }}
                        </ion-col>
                        <ion-col [ngClass]="isManagement ? 'management-last-col-style' : 'col-style last-col'" centered>
                            {{ getTotalEvaluators(user?.ratings?.directReportRatings) }}
                        </ion-col>
                    </ng-template>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
    <ion-row [ngClass]="isManagement ? 'management-body' : 'body'">
        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" size="3">
            <ion-grid>
                <ion-row>
                    <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" class="first-col">
                        {{ 'dashboard.freeEvaluation' | translate }}
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" size="9">
            <ion-grid>
                <ion-row>
                    <ng-container *ngIf="showTooltips; else withTooltipFreeEvaluators">
                        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" centered *ngFor="let rating of user?.ratings?.ratingsPossibleValues">
                            {{ user?.ratings?.freeEvaluationRatings[rating] }}
                        </ion-col>
                        <ion-col [ngClass]="isManagement ? 'management-last-col-style' : 'col-style last-col'" centered>
                            {{ getTotalEvaluators(user?.ratings?.freeEvaluationRatings) }}
                        </ion-col>
                    </ng-container>
                    <ng-template #withTooltipFreeEvaluators>
                        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" centered *ngFor="let rating of user?.ratings?.ratingsPossibleValues"
                                 [matTooltip]="user?.evaluators?.freeEvaluators ? user?.evaluators?.freeEvaluators[rating] : ''">
                            {{ user?.ratings?.freeEvaluationRatings[rating] }}
                        </ion-col>
                        <ion-col [ngClass]="isManagement ? 'management-last-col-style' : 'col-style last-col'" centered [matTooltip]="getAllEvaluators(user?.evaluators?.freeEvaluators)">
                            {{ getTotalEvaluators(user?.ratings?.freeEvaluationRatings) }}
                        </ion-col>
                    </ng-template>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>

    <ion-row [ngClass]="isManagement ? 'management-total' : 'total'">
        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" size="3">
            <ion-grid>
                <ion-row>
                    <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'">
                        TOTAL
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" size="9">
            <ion-grid>
                <ion-row>
                    <ng-container *ngIf="showTooltips; else withTooltipRatingTotals">
                        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" *ngFor="let rating of user?.ratings?.ratingsPossibleValues" centered colored highlight
                                 [matTooltip]="getRatingTotalEvaluators(rating)">
                            {{ getRatingTotals(rating) }}
                        </ion-col>
                    </ng-container>
                    <ng-template #withTooltipRatingTotals>
                        <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'" *ngFor="let rating of user?.ratings?.ratingsPossibleValues" centered colored highlight>
                            {{ getRatingTotals(rating) }}
                        </ion-col>
                    </ng-template>
                    <ion-col [ngClass]="isManagement ? 'management-col-style' : 'col-style'"></ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
</ion-grid>